import { SuperAction } from "../SuperAction";

export class OnAnketaGetResults extends SuperAction {};
export function anketaGetResults() {
  return new OnAnketaGetResults();
}
export class OnAnketaGetPrice extends SuperAction {};
export function anketaGetPrice() {
  return new OnAnketaGetPrice();
}